import {useTranslation} from "ni18n";
import React from "react";

import CovidReadyForm from "./CovidReadyForm";
import styles from "./Signup.module.scss";

const Signup = (props: any) => {
  const i18n = useTranslation();
  const {industryList, submitted}: any = props;

  return (
    <div className={styles.wrap} id="signup">
      <div className={styles.n}>
        <div className={styles.n0}>
          <div className={styles.n00}>
            {/* @ts-expect-error TS7006: Parameter 's' implicitly has an 'any' type. */}
            {industryList.map(s => (
              <div key={s} className={styles.n000}>
                {s}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.n1}>
          <div className={styles.n10}>
            <h2 className={styles.n100}>{i18n.t("Sign up now")}</h2>
            <div className={styles.n1000}>
              {submitted && (
                <div className={styles.sub}>
                  <span className={`${styles.sub0} cIcon-ok2`} />
                  <div className={styles.sub1}>
                    {i18n.t(
                      "Thank you. Someone from our Covid Ready team will be in touch with you soon.",
                    )}
                  </div>
                </div>
              )}

              {!submitted && <CovidReadyForm {...props} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
